import { render, staticRenderFns } from "./ShopCreateQuery.vue?vue&type=template&id=3614ca20&scoped=true&"
import script from "./ShopCreateQuery.vue?vue&type=script&lang=js&"
export * from "./ShopCreateQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3614ca20",
  null
  
)

export default component.exports